import IconButtonMUI from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useTranslationApp } from "../../lib/i18next";
import Loader from "../Loaders/Loader";

const IconButton = ({
  id = "",
  children,
  loading = false,
  loaderColor = "primary",
  sx = {},
  disabled = false,
  disableRipple = false,
  onClick = () => {},
  tooltipText,
  edge = "end",
  className = "",
  tabIndex,
}) => {
  const { t } = useTranslationApp();
  return (
    <Tooltip title={tooltipText ? t(tooltipText) : ""}>
      <span style={{ display: "inline-flex" }}>
        <IconButtonMUI
          id={id}
          className={className}
          disableRipple={disableRipple}
          disabled={disabled}
          tabIndex={tabIndex}
          onClick={(e) => onClick(e)}
          sx={{
            color: "background.paperContrastText",
            "&:hover": {
              color: "background.paperContrastText",
            },
            ...sx,
          }}
          edge={edge}
        >
          {loading && (
            <Loader hasMarginTop={false} size={20} colorCustom={loaderColor} />
          )}
          {!loading && children}
        </IconButtonMUI>
      </span>
    </Tooltip>
  );
};

export default IconButton;
